<template>
    <svg width="23"
         height="22"
         viewBox="0 0 23 22"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <rect x="0.800049"
              width="22"
              height="22"
              rx="11"
              fill="#184495" />
        <path d="M11.8 12V7"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
        <circle cx="11.8"
                cy="15"
                r="1"
                fill="white" />
    </svg>
</template>

<script>
export default {
    name: 'IconSuccess'
};
</script>
